import Link from "next/link";
import { FC } from "react";

interface Props {
  item: {
    title: string;
    link: string;
    firstIcon: React.FC<any>;
    secondIcon: React.ReactNode;
  };
  id: string;
}
const AppLink: FC<Props> = ({ item, id }) => {
  const Icon = item.firstIcon;
  return (
    <Link href={item.link} key={item.title} target="_blank" className="w-full">
      <button className="w-full lg:w-[200px] justify-center flex text-fds-on-brand gap-x-4 flex-row items-center bg-fds-brand-dark border border-zinc-200 rounded-lg h-[62px]">
        <p className="!font-normal  flex flex-col items-center  !text-xs">
          {item.title}
          <br />
          {item.secondIcon}
        </p>
        <Icon id={id} fill={"#fff"} />
      </button>
    </Link>
  );
};

export default AppLink;
